// extracted by mini-css-extract-plugin
export var modal = "_mb-0";